import { Slot } from "@radix-ui/react-slot";
import { cn } from "../lib/utils";

type Props = React.HTMLAttributes<HTMLElement> & {
  asChild?: boolean;
};

export function Display({ asChild, className, ...props }: Props) {
  const Comp = asChild ? Slot : "h1";
  return (
    <Comp
      className={cn("text-4xl text-center font-semibold", className)}
      {...props}
    />
  );
}

export function Headline({ asChild, className, ...props }: Props) {
  const Comp = asChild ? Slot : "h1";
  return <Comp className={cn("text-lg", className)} {...props} />;
}

export function Title({ asChild, className, ...props }: Props) {
  const Comp = asChild ? Slot : "h1";
  return (
    <Comp
      className={cn("text-xl leading-none font-semibold", className)}
      {...props}
    />
  );
}

export function Label({ asChild, className, ...props }: Props) {
  const Comp = asChild ? Slot : "p";
  return <Comp className={cn("text-muted-foreground", className)} {...props} />;
}
